import { createSelector } from 'reselect';

import { CardDatum } from '../../types/DirectPayCard';
import { getMaskedCreditCard } from '../../utils/getMaskedCreditCard';
import isExists from '../../utils/isExists';
import { RootState } from '../rootReducer';

const directPayCardsRow = (state: RootState) =>
  state?.directPayCardsReducer || {};

export const makeDirectPayCards = () =>
  createSelector(directPayCardsRow, row => {
    const cardData = row.card_data;

    return isExists(cardData)
      ? cardData.map(cardDatum => ({
          ...cardDatum,
          number: getMaskedCreditCard(cardDatum.number, 4),
        }))
      : [];
  });

export const makeDirectPayDefaultCard = () =>
  createSelector(makeDirectPayCards(), cardData => {
    const defaultCard = cardData.find(cardDatum => cardDatum.is_primary);

    return defaultCard || {};
  });

/*
  這邊是用來判斷此用戶的「卡片列表」是否曾有卡片，目的為判斷是否在 web 那要顯示「設為預設」的 UI，
  若卡片列表沒卡片，代表為第一次用 direct pay，第一張卡強制設為預設，因此不需給 UI 選擇是否要「設為預設」
*/
export const hasMultipleCard = () =>
  createSelector(
    makeDirectPayDefaultCard(),
    (cardDatum: CardDatum) => Object.keys(cardDatum).length > 0
  );

export const makePutDirectPayPrimaryCardIsLoading = () =>
  createSelector(directPayCardsRow, row => {
    return row.isFetchingCardList;
  });

export const makeSubmittingNewDirectPayCard = () =>
  createSelector(directPayCardsRow, row => {
    return (
      row.isFetchingCardList || row.isSavingCard || row.isFetchingPaymentMethods
    );
  });
